import { InfoIcon } from 'lucide-react';
import React from 'react';

import { Tooltip } from '@/components/Tooltip';

export interface QueryNameProps {
  value: string;
  editable: boolean;
  description?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function QueryName({
  value,
  editable,
  description,
  onChange,
}: QueryNameProps) {
  if (editable) {
    return (
      <input
        type="text"
        value={value}
        onChange={onChange}
        className="text-chariot-text-primary w-full bg-transparent text-xl font-semibold outline-none"
        placeholder="Query name"
        data-testid="query-header-name-input"
      />
    );
  }

  return (
    <div className="flex items-center gap-2">
      <h2 className="text-chariot-text-primary text-xl font-semibold">
        {value}
      </h2>
      {description && (
        <Tooltip title={description} tooltipClassName="max-w-md">
          <InfoIcon
            className="text-chariot-text-secondary size-4 shrink-0 cursor-help"
            aria-label="Show query description"
          />
        </Tooltip>
      )}
    </div>
  );
}
